import { Component, Inject, OnInit } from '@angular/core';
import { MapsAPILoader, MouseEvent } from '@agm/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {} from 'googlemaps';

@Component({
  selector: 'app-maps-dialog',
  templateUrl: './maps-dialog.component.html',
  styleUrls: ['./maps-dialog.component.scss'],
})
export class MapsDialogComponent implements OnInit {
  lat = -33.442528;
  long = -70.6343592;
  markers = [];
  private geoCoder;
  constructor(
    public dialogRef: MatDialogRef<MapsDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      marker: {
        lat: number;
        lng: number;
        draggable: boolean;
        address: string;
      };
    },
    private mapsAPILoader: MapsAPILoader
  ) {
    if (data.marker) {
      this.lat = data.marker.lat;
      this.long = data.marker.lng;
      this.markers = [data.marker];
    }
  }

  ngOnInit(): void {
    this.mapsAPILoader.load().then(() => {
      this.geoCoder = new google.maps.Geocoder();
    });
  }

  mapClicked($event: MouseEvent): void {
    let address;
    this.geoCoder.geocode(
      { location: { lat: $event.coords.lat, lng: $event.coords.lng } },
      (results, status) => {
        if (status === 'OK') {
          if (results[0]) {
            address = results[0].formatted_address;
          }
        }
        this.markers = [
          {
            lat: $event.coords.lat,
            lng: $event.coords.lng,
            draggable: false,
            address,
          },
        ];
      }
    );
    this.markers = [
      {
        lat: $event.coords.lat,
        lng: $event.coords.lng,
        draggable: false,
        address,
      },
    ];
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onAddLocation(): void {
    this.dialogRef.close(this.markers[0]);
  }
}
